import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import BackgroundSlideshow from 'react-background-slideshow';
import scrollToElement from 'scroll-to-element';

class HomeCarousel extends Component {
    
    constructor(){
        super()

        this.scrollHandle = this.scrollHandle.bind();
    }

    scrollHandle() {
        scrollToElement('.scroll-stop', { offset: -70, duration: 450 });
    }

    render() {
        let images = [
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/14.jpg',
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/4.jpg',
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/5.jpg',
            'https://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,q_auto:eco,w_1200/v1507923985/bikes_background/6.jpg',
        ]
        
		return (
			<section className="carousel">

                <BackgroundSlideshow images={images} animationDelay={4000} disableClick={ () => {} } disableInterval={ () => {} }/>
 
                <div className="container">
                    <div className="table-wrapper">
                        <div className="table-cell">
                            <div className="hero-badge">Mere end 15 års erfaring i København</div>
                            <h2>Din Cykelforretning &amp; Værksted</h2>
                            <p>
                                Velkommen til en ny verden af kvalitetscykler – vi kombinerer dansk cykeltradition, personlig rådgivning og professionelt værksted ved Husum Torv.
                            </p>
                            <ul className="hero-features">
                                <li><span className="pe-7s-shield" /> 10 års stelgaranti</li>
                                <li><span className="pe-7s-tools" /> Samme-dags reparation</li>
                                <li><span className="pe-7s-box2" /> Levering i Storkøbenhavn fra 200 DKK</li>
                                <li><span className="pe-7s-check" /> Eftersyn fra 279 kr.</li>
                            </ul>
                            <div className="hero-cta">
                                <Link to="/cycles" className="btn btn-primary btn-lg">Se Cykler</Link>
                                <Link to="/repairs" className="btn btn-default btn-lg">Værksted &amp; Priser</Link>
                            </div>
                            <span className="pe-7s-angle-down-circle" onClick={this.scrollHandle}></span>
                        </div>
                    </div>
                </div>
            </section>
		);
	}
}

export default HomeCarousel;



// WEBPACK FOOTER //
// ./src/Components/HomeCarousel.js